import { ref } from 'vue';

export default function useOnboarding(browser) {
  const extensionInstalled = ref(false);
  const extensionInstalledLoading = ref(true);
  const extensionIsPinned = ref(false);
  const extensionIsPinnedLoading = ref(true);
  const checkIfExtensionIsInstalled = () => {
    browser.runtime.sendMessage(import.meta.env.VITE_EXTENSION_ID, { checkIfExtensionIsInstalled: true }).then((res) => {
      extensionInstalled.value = res;
    }).catch(() => {
      extensionInstalled.value = false;
      setTimeout(checkIfExtensionIsInstalled, 2000);
    }).finally(() => {
      extensionInstalledLoading.value = false;
    });
  };
  const checkIfExtensionIsPinned = () => {
    browser.runtime.sendMessage(import.meta.env.VITE_EXTENSION_ID, { checkIfExtensionIsPinned: true }).then((res) => {
      extensionIsPinned.value = res;
      if (!res) {
        setTimeout(checkIfExtensionIsPinned, 2000);
      }
    }).catch(() => {
      extensionIsPinned.value = false;
      setTimeout(checkIfExtensionIsPinned, 2000);
    }).finally(() => {
      extensionIsPinnedLoading.value = false;
    });
  };

  const pinHintDismissed = ref(localStorage.getItem('pinHintDismissed') === 'true');
  const dismiss = () => {
    localStorage.setItem('pinHintDismissed', 'true');
    pinHintDismissed.value = true;
  };

  const init = () => {
    if (browser.runtime === undefined) {
      return;
    }
    checkIfExtensionIsInstalled();
    checkIfExtensionIsPinned();
  };

  init();

  return { extensionInstalled, extensionInstalledLoading, extensionIsPinned, extensionIsPinnedLoading, dismiss, pinHintDismissed };
}
